import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faEnvelope, faLocationDot, faPhone } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';

import Button from '../Button';

type Cta = {
  label: string;
  href: string;
  id: string;
};

type Props = {
  phone: string;
  email: string;
  address?: string;
  ctas?: Cta[];
  textClassName?: string;
};

const InfoRow = ({ icon, label, textClassName }: { icon: IconDefinition; label: string; textClassName?: string }) => (
  <div className={twMerge('flex items-center gap-3', textClassName)}>
    <FontAwesomeIcon icon={icon} />
    <span>{label}</span>
  </div>
);

const ContactInfoBlock = ({ phone, email, address, ctas, textClassName }: Props) => (
  <div className="flex flex-col gap-3">
    <InfoRow icon={faPhone} label={phone} textClassName={textClassName} />
    <InfoRow icon={faEnvelope} label={email} textClassName={textClassName} />
    {address && <InfoRow icon={faLocationDot} label={address} textClassName={textClassName} />}
    {ctas && (
      <div className="flex flex-col">
        {ctas.map(cta => (
          <Button
            className="border-b-green [&>*]:text-md w-fit pb-1"
            href={cta.href}
            key={cta.id}
            label={cta.label}
            labelClassName={textClassName}
            type="tertiary"
          />
        ))}
      </div>
    )}
  </div>
);

export default ContactInfoBlock;
